<template>
  <div class="container">
    <el-container>
      <el-header class="header">
        <headers />
      </el-header>

      <el-container>
        <slider />

        <el-main>
          <div class="main_box">
            <div class="main_main">
              <!-- Page Header -->
              <div class="page_header">Permission Configuration</div>

              <!-- Description -->
              <div class="desc_box">
                <div class="desc_title">
                  Assign the following roles to users to grant the corresponding module management permissions:
                </div>
                <ul class="desc_list">
                  <li>* System Administrator - Responsible for managing the entire system.</li>
                  <li>* User Administrator - Has permission to create and edit user accounts.</li>
                  <li>
                    * Document Control Administrator - Responsible for configuring the Document Control module. If no user is assigned to this role, the System Administrator will assume this responsibility.
                  </li>
                  <li>
                    * CAPA Administrator - Responsible for configuring the CAPA module. If no user is assigned to this role, the System Administrator will assume this responsibility.
                  </li>
                  <li>
                    * Training Administrator - Responsible for configuring the Training Management module. If no user is assigned to this role, the System Administrator will assume this responsibility.
                  </li>
                </ul>
              </div>

              <!-- Table -->
              <div class="table_card">
                <div class="table_header">
                  <div class="table_title">
                    Assigned Users
                    <div style="display: inline-block;padding-left: 20px;">
                      <el-button
                        type="primary"
                        size="medium"
                        @click="goUrl('/system/config/add-edit')"
                      >
                        Assign Permissions
                      </el-button>
                    </div>
                  </div>

                  <div class="table_search">
                    <el-input
                      v-model="query.keyword"
                      placeholder="Please enter a user name"
                      size="small"
                      clearable
                    >
                    </el-input>

                    <el-button
                      type="primary"
                      size="small"
                      @click="handleSearch"
                    >
                      Search
                    </el-button>
                  </div>
                </div>

                <!-- Table -->
                <div class="table_card">
                  <el-table
                    v-loading="tableLoading"
                    :data="tableData"
                    border
                    class="table_el"
                    ref="multipleTable"
                    header-cell-class-name="table-header"
                  >
                    <el-table-column
                      prop="id"
                      label="Action"
                      width="80"
                      align="center"
                    >
                      <template #default="scope">
                        <div class="inline_btn">
                          <el-button
                            type="primary"
                            size="mini"
                            @click="handleClick('Edit', scope.row)"
                          >
                            Edit
                          </el-button>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="user_id"
                      label="User"
                      :show-overflow-tooltip="true"
                      align="center"
                    ></el-table-column>

                    <el-table-column
                      prop="system"
                      label="System Administrator"
                      :show-overflow-tooltip="true"
                      align="center"
                    >
                      <template #default="scope">
                        {{ formatYesNo(scope.row.system) }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="users"
                      label="User Administrator"
                      :show-overflow-tooltip="true"
                      align="center"
                    >
                      <template #default="scope">
                        {{ formatYesNo(scope.row.users) }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="documents"
                      label="Document Control Administrator"
                       width="320"
                      :show-overflow-tooltip="true"
                      align="center"
                    >
                      <template #default="scope">
                        {{ formatYesNo(scope.row.documents) }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="capa"
                      label="CAPA Administrator"
                      :show-overflow-tooltip="true"
                      align="center"
                    >
                      <template #default="scope">
                        {{ formatYesNo(scope.row.capa) }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="train"
                      label="Training Administrator"
                      :show-overflow-tooltip="true"
                      align="center"
                    >
                      <template #default="scope">
                        {{ formatYesNo(scope.row.train) }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="id"
                      label="Action"
                      width="120"
                      align="center"
                    >
                      <template #default="scope">
                        <div class="inline_btn mr_l">
                          <el-button
                            type="danger"
                            size="mini"
                            @click="handleClick('Delete', scope.row)"
                          >
                            Delete
                          </el-button>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>

                  <div class="pagination">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePageChange"
                      :current-page="query.page"
                      :page-sizes="[5, 10, 20, 50]"
                      :page-size="query.page_size"
                      layout="total, sizes, prev, pager, next"
                      :total="pageTotal"
                    >
                    </el-pagination>
                  </div>
                </div>
                <!-- End Table -->
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import { authRuleList, authRuleDel } from "../../../api/system/config";

export default {
  components: {
    headers,
    slider,
  },
  data() {
    return {
      tableLoading: true,
      query: {
        keyword: "",
        page: 1,
        page_size: 10,
      },
      tableData: [],
      pageTotal: 0, //总条数
    };
  },
  mounted() {
    let that = this;
    that.getList();
  },
  methods: {
    // 获取列表
    getList() {
      let that = this;
      that.tableLoading = true;
      authRuleList(that.query).then((res) => {
        that.tableData = res.data.data;
        that.pageTotal = res.data.total;
        that.tableLoading = false;
      });
    },
    formatYesNo(val) {
      return Number(val) === 1 ? "Yes" : "No";
    },
    //搜索
    handleSearch() {
      let that = this;
      that.tableLoading = true;
      that.query.page = 1;
      that.getList();
    },
    //条数选择
    handleSizeChange(value) {
      let that = this;
      that.query.page_size = value;
      that.getList();
    },
    //页数跳转
    handlePageChange(value) {
      let that = this;
      that.query.page = value;
      that.getList();
    },
    //操作按钮点击
    handleClick(name, value) {
      let that = this;
      switch (name) {
        case "Edit":
          that.$router.push({
            path: "/system/config/add-edit",
            query: {
              oid: value.id,
              obj: encodeURIComponent(JSON.stringify(value)),
            },
          });
          break;
        case "Delete":
          that
            .$confirm("Are you sure you want to delete this item?", "Confirmation", {
              type: "warning",
            })
            .then(() => {
              //删除接口
              that.$toast.loading({ duration: 0, forbidClick: true });
              authRuleDel({ id: value.id }).then((res) => {
                that.$toast.clear();
                that.$message("Operation successful");
                that.getList();
              });
            })
            .catch(() => {});
          break;
      }
    },
    //取消
    cancel() {
      this.$router.back();
    },
    // 跳转页面
    goUrl(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style lang="less" scoped>
// 页面整体主内容
.main_main {
  background: #fafafa;
  min-height: 100%;

  // 页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }

  // 说明区域
  .desc_box {
    margin: 20px;
    padding: 18px 20px;
    background: #fdf6ec;
    border-radius: 6px;
    color: #333;

    .desc_title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .desc_list {
      margin: 0;
      padding-left: 20px;

      li {
        line-height: 28px;
        font-size: 14px;
      }
    }
  }

  // 表格区域
  .table_card {
    margin: 20px 20px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;

    .table_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 16px;
      border-bottom: 1px solid #ebeef5;
      background: #fff;

      .table_title {
        font-size: 18px;
        font-weight: bold;
        color: #303133;
      }

      .table_search {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 360px;
      }
    }

    .pagination {
      margin: 10px 0;
      text-align: right;
    }
  }

  // 底部按钮
  .bottom_btn_box {
    display: flex;
    justify-content: center;
    padding: 20px 0 30px;
  }
}
</style>

<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.main_box .main_main {
  position: relative;
  min-height: 100%;
  background-color: #fafafa;
}

.el-header,
.el-main {
  padding: 0;
}
</style>